import React from "react";
import PropTypes from "prop-types";
const ShippingIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h24v24H-2z" />
      <path
        d="M2.257 4.097l7-2.8a2 2 0 0 1 1.486 0l7 2.8A2 2 0 0 1 19 5.954v8.092a2 2 0 0 1-1.257 1.857l-6.997 2.8a2 2 0 0 1-1.486 0l-7.003-2.8A2 2 0 0 1 1 14.046V5.954a2 2 0 0 1 1.257-1.857z"
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="2"
        d="M.538 5.375L10 9.401l9.37-4.026"
      />
      <path fill={color || "var(--color-easil-gray-x-dark)"} d="M9 9h2v10H9z" />
      <path
        d="M15.083 2.93L5 7.246"
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="2"
      />
    </g>
  </svg>
);
ShippingIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ShippingIcon;
